import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ImportFileResponse, ImportFileResponseEmployee } from '../../../state/import.model';
import { ImportEntityType } from '../import-by-entity/import-by-entity.component';

@Component({
    selector: 'app-import-by-entity-preview',
    templateUrl: './import-by-entity-preview.component.html',
    styleUrls: ['./import-by-entity-preview.component.css'],
})
export class ImportByEntityPreviewComponent implements OnChanges {
    @Input() public importFileResponse: ImportFileResponse;
    @Input() public importFileResponseEmployee: ImportFileResponseEmployee;
    @Input() public entity: ImportEntityType;
    @Input() public confirmImportForm: FormGroup;

    public errorsCount = 0;
    public warningsCount = 0;
    public collapsedSections = [true, true, true, true];

    public constructor() { }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.importFileResponse || changes.importFileResponseEmployee) {
            this.warningsCount = 0;
            this.errorsCount = 0;
            this.collapsedSections = [true, true, true, true];

            if (changes.importFileResponse && this.importFileResponse) {
                this.errorsCount = this.importFileResponse.errors.length;
                this.warningsCount = this.importFileResponse.warnings.length;
            }

            if (changes.importFileResponseEmployee && this.importFileResponseEmployee) {
                for (const [key, value] of Object.entries(this.importFileResponseEmployee.warnings)) {
                    this.warningsCount = this.warningsCount + value.length;
                }
                for (const [key, value] of Object.entries(this.importFileResponseEmployee.errors)) {
                    this.errorsCount = this.errorsCount + value.length;
                }
            }
        }
    }
}
